// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 广告营销服务申请详情 GET /promotion-service-apply/info */
export async function promotionServiceApplyInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionServiceApplyInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionServiceApplyInfoResp>('/promotion-service-apply/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 广告营销服务提交申请 POST /promotion-service-apply/submit */
export async function promotionServiceApplySubmitUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionServiceApplySubmitUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/promotion-service-apply/submit', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
